import { useFetchApps, useFetchOrgs, useGetListTextFields } from "@lhd/hooks";
import { Form, Select, Spin } from "antd";
import debounce from "lodash/debounce";
import { useMemo, useRef, useState } from "react";
import { FormInstance } from "antd/es/form/Form";
import { CUSTOM_OPTION, CustomAppSelectOption } from "../constants";
import { workerTextFieldOptions } from "../../utils";
import { ERRORS_MESSAGE } from "@lhd/constants";

const FieldSelect = ({
  appId,
  form,
  getFieldClassName,
}: {
  appId: string;
  form: FormInstance<any>;
  getFieldClassName?: (name: string) => string;
}) => {
  const fetchRef = useRef(0);
  const name = "referenced_type";
  const [
    page,
    // setPage,
  ] = useState(1);
  const value = form.getFieldValue(name);

  const isAppValue = useMemo(() => {
    const valueFind = CUSTOM_OPTION.find((op) => op.value === value);
    return !valueFind;
  }, [value]);

  const [filterParams, setFilter] = useState({});
  const { data: listOrg, isFetching: isOrgFetching } = useFetchOrgs(
    undefined,
    undefined,
    undefined,
    !isAppValue,
  );
  const { data: appData, isFetching: isAppDataFetching } = useGetListTextFields(
    appId || "",
    filterParams,
    isAppValue && !!value,
  );

  const [searchKey, setSearchKey] = useState("");
  const options = useMemo(() => {
    if (appId === CustomAppSelectOption.ORG) {
      return listOrg?.data
        ?.map((org) => {
          return { label: org.name, value: org.id };
        })
        .filter((org) =>
          org.label.toLowerCase().includes(searchKey.toLowerCase()),
        );
    }
    if (appId === CustomAppSelectOption.POSITION) {
      return [
        { label: "役職", value: 0 },
        { label: "レベル", value: 1 },
      ].filter((org) =>
        org.label.toLowerCase().includes(searchKey.toLowerCase()),
      );
    }
    if (appId === CustomAppSelectOption.WORKER) {
      return workerTextFieldOptions.filter((workerOption) =>
        workerOption.label.toLowerCase().includes(searchKey.toLowerCase()),
      );
    }
    if (!appData) return [];
    return appData?.data?.map((field) => {
      return {
        label: `${field.label_text || field.name} ${
          field?.field_code ? `(${field?.field_code})` : ""
        }`,
        value: field.id,
      };
    });
  }, [appData, appId, listOrg?.data, searchKey]);
  const debounceFetcher = useMemo(() => {
    if (
      appId === CustomAppSelectOption.WORKER ||
      appId === CustomAppSelectOption.POSITION ||
      appId === CustomAppSelectOption.ORG
    ) {
      return setSearchKey;
    }
    const loadOptions = (name_cont: string) => {
      fetchRef.current += 1;
      setFilter({ q: { name_cont } });
    };

    return debounce(loadOptions, 500);
  }, [setFilter, appId]);

  return (
    <Spin spinning={isOrgFetching || isAppDataFetching}>
      <Form.Item
        // extra={<div>設定後にデータソースが変更できない</div>}
        label="列選択"
        rules={[{ required: true, message: ERRORS_MESSAGE.REQUIRED }]}
        name={
          appId === CustomAppSelectOption.WORKER
            ? "referenced_worker_property"
            : "referenced_app_part_id"
        }
        className={`${getFieldClassName?.("referenced_app_part_id")}`}
        validateTrigger="onBlur"
      >
        <Select
          style={{ width: 350 }}
          onClear={() => setFilter({})}
          allowClear
          showSearch
          filterOption={false}
          placeholder="列選択"
          options={appId ? options : []}
          onSearch={debounceFetcher}
        />
      </Form.Item>
    </Spin>
  );
};
export default FieldSelect;
